// Copyright 2026. WebPros International GmbH. All rights reserved.
import styled from 'styled-components';

export const EmptyView = styled.div`
    text-align: center;
    padding: 30px 0;
`;
export const MarginTopBottom = styled.div`
    margin-top: 15px;
    margin-bottom: 15px;
`;
